import React, { useCallback, useState } from "react";

type CustomChangeEvent = {
  target: { type: "checkbox"; checked: boolean; name: string };
};

type CallBackProps =
  | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  | CustomChangeEvent;
/**
 * Hooks to manage inputs fields
 * @category Category Name
 *
 * @param Object, initialValues
 * @param Function, callback, method call each time inputs changes
 * @returns Object containing....
 */
const useInput = <T extends Record<string, any>>(
  initialValues: T,
  callback?: (evt: CallBackProps) => void
) => {
  const [inputs, setInputs] = useState<T>(initialValues);

  const handleInputChange = useCallback(
    (evt: CallBackProps) => {
      const { target } = evt;
      const value =
        target.type === "checkbox"
          ? (target as HTMLInputElement).checked
          : (target as HTMLTextAreaElement).value;
      setInputs(inputs => ({ ...inputs, [target.name]: value }));
      if (callback) callback(evt);
    },
    [callback]
  );

  return {
    inputs,
    handleInputChange,
    initialValues,
    setInputs
  };
};

export default useInput;
